import React from 'react';
import './BannerECommerce.scss';
import Link from 'Components/Shared/Link/Link';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import { Link as RouterLink } from 'react-router-dom';

interface IProps {
  eCommerceContent: Julius.Content.Banner;
}

class BannerECommerce extends React.Component<IProps> {
  componentDidUpdate() {
    const script = document.createElement('script');
    script.src = 'https://cert.tryggehandel.net/js/script.js?id=db6d91a2-0da4-4186-8c93-7b0da1a4c771';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  render() {
    const {
      eCommerceContent,
    } = this.props;
  
    if (!eCommerceContent) {
      return null;
    }
    
    return (
      <WrapperLayout style='banner-ecommerce' justify='center' align='middle' padding='lg'>
        <div className='teh-certificate' />
        <div className='teh-description'>
          <span className='title'>{ eCommerceContent.title }</span>
          <span className='text' dangerouslySetInnerHTML={ { __html: eCommerceContent.text } } />
          <RouterLink to='/tryggehandel' >
            <Link 
              style='link'
              displayName='Läs mer'
            />
          </RouterLink>
        </div>
      </WrapperLayout>
    );
  }
};

export default BannerECommerce;


// WEBPACK FOOTER //
// ./src/components/BannerECommerce/BannerECommerce.tsx